
import saveFileByUrl from '../src';
import { defineComponent, ref } from 'vue';
import Download from './download.vue';

export default defineComponent({
  name: 'App',
  components: { Download },
  setup() {
    const url = ref('https://cdn.mockuai.com/tms/template.xlsx');
    return {
      url,
      onDownloadHTML() {
        saveFileByUrl(window.location.href);
      },
      customDownload() {
        saveFileByUrl(url.value);
      },
    };
  },
});
